export default "__VITE_ASSET__DX1D9qPG__"